import {NgModule} from '@angular/core';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {CertificateNkModule} from '../certificates/nk.module';
import {CertificatePbModule} from '../certificates/pb.module';
import {SpecialistFormFieldsCommonComponent} from './specialist-form-fields-common/specialist-form-fields-common.component';
import {SpecialistFormFieldsContactsComponent} from './specialist-form-fields-contacts/specialist-form-fields-contacts.component';
import {SpecialistFormFieldsPassportComponent} from './specialist-form-fields-passport/specialist-form-fields-passport.component';
import {SpecialistFormFieldsEducationComponent} from './specialist-form-fields-education/specialist-form-fields-education.component';
import {SpecialistFormFieldsMedicalComponent} from './specialist-form-fields-medical/specialist-form-fields-medical.component';
import {
    SpecialistFormFieldsCertificatesNkComponent
} from './specialist-form-fields-certificates-nk/specialist-form-fields-certificates-nk.component';
import {
    SpecialistFormFieldsCertificatesPbComponent
} from './specialist-form-fields-certificates-pb/specialist-form-fields-certificates-pb.component';
import {SpecialistFormFieldsAgreementsComponent} from './specialist-form-fields-agreements/specialist-form-fields-agreements.component';
import {LayoutModule} from '../../layout-components/layout.module';
import {DirectivesModule} from '@helpers/directives/directives.module';
import {SpecialistFormFieldsJobComponent} from './specialist-form-fields-job/specialist-form-fields-job.component';
import {SpecialistFormFieldsClothesComponent} from './specialist-form-fields-clothes/specialist-form-fields-clothes.component';
import {SpecialistFormFieldsPermitsComponent} from './specialist-form-fields-permits/specialist-form-fields-permits.component';
import {PermitSubformComponent} from './specialist-form-fields-permits/permit-subform.component';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {IconsModule} from '@lab365/icons';

/**
 * Модуль с блоками полей формы сотрудника.
 * Испортирует в себя все блоки и экспортирует все блоки, чтобы в других местах их можно было использовать
 * */

@NgModule({
    declarations: [
        SpecialistFormFieldsCommonComponent,
        SpecialistFormFieldsContactsComponent,
        SpecialistFormFieldsPassportComponent,
        SpecialistFormFieldsEducationComponent,
        SpecialistFormFieldsMedicalComponent,
        SpecialistFormFieldsCertificatesNkComponent,
        SpecialistFormFieldsCertificatesPbComponent,
        SpecialistFormFieldsAgreementsComponent,
        SpecialistFormFieldsJobComponent,
        SpecialistFormFieldsClothesComponent,
        SpecialistFormFieldsPermitsComponent,

        PermitSubformComponent,
    ],
    exports: [
        SpecialistFormFieldsCommonComponent,
        SpecialistFormFieldsContactsComponent,
        SpecialistFormFieldsPassportComponent,
        SpecialistFormFieldsEducationComponent,
        SpecialistFormFieldsMedicalComponent,
        SpecialistFormFieldsCertificatesNkComponent,
        SpecialistFormFieldsCertificatesPbComponent,
        SpecialistFormFieldsAgreementsComponent,
        SpecialistFormFieldsJobComponent,
        SpecialistFormFieldsClothesComponent,
        SpecialistFormFieldsPermitsComponent,
    ],
    imports: [
        FormFieldModule,
        ReactiveFormsModule,
        CommonModule,
        LayoutModule,
        DirectivesModule,
        CertificateNkModule,
        CertificatePbModule,
        FilesUploaderModule,
        IconsModule,
    ],
    providers: [
    ]
})
export class SpecialistFormFieldsModule {}
